// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38jKH","type":"styles_type__2xozl","choices":"styles_choices__DaAxB"};